/**
 * Keys to commands (the key table on the wiki page Architecture → game-core
 * contract): arrows or W A S D and Q E Z C move in 8 directions, Shift with a
 * direction turns, space waits, F attacks, > descends. Every key builds one
 * command; whether it is legal is game-core's call.
 */
import type { Command, Dir } from '@ab/game-core';

const dirKeys: Readonly<Partial<Record<string, Dir>>> = {
  ArrowUp: 'n',
  w: 'n',
  e: 'ne',
  ArrowRight: 'e',
  d: 'e',
  c: 'se',
  ArrowDown: 's',
  s: 's',
  z: 'sw',
  ArrowLeft: 'w',
  a: 'w',
  q: 'nw',
};

export const commandForKey = (key: string, shift: boolean): Command | null => {
  const k = key.length === 1 ? key.toLowerCase() : key;
  const dir = Object.hasOwn(dirKeys, k) ? dirKeys[k] : undefined;
  if (dir !== undefined) return shift ? { type: 'turn', dir } : { type: 'move', dir };
  if (key === ' ') return { type: 'wait' };
  if (k === 'f' && !shift) return { type: 'attack' };
  if (key === '>') return { type: 'descend' };
  return null;
};
